module.exports = __webpack_public_path__ + "static/media/homem_r1_c5.aa66bd7c.jpg";